export default [
  {
    path: '/user/register',
    name: 'register',
    component: () => import('@/views/user/register.vue'),
    meta: {
      title: '注册',
    },
  },
  {
    path: '/user/login',
    name: 'login',
    component: () => import('@/views/user/login.vue'),
    meta: {
      title: '登录',
    },
  },
  {
    path: '/aboutUs/centerProfile',
    name: 'centerProfile',
    component: () => import('@/views/aboutUs/centerProfile.vue'),
    meta: {
      title: '中心简介',
    },
  },
  {
    path: '/aboutUs/contactUs',
    name: 'contactUs',
    component: () => import('@/views/aboutUs/contactUs.vue'),
    meta: {
      title: '联系我们',
    },
  },
  {
    path: '/user/center',
    name: 'personalCenter',
    component: () => import('@/views/user/personalCenter.vue'),
    meta: {
      title: '我的案件',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    },
  },
];
